import { SearchOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, FormInstance, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GetProducers from '~/@core/application/useCases/rfidReports/inventory/getProducers';
import GetDones from '~/@core/application/useCases/rfidReports/receipt/getDones';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import NonConformity from '~/@core/domain/model/rfidReports/NonConformity';
import Producer from '~/@core/domain/model/rfidReports/Producer';
import FormFilterDataModel, {
  MapFormToFilter
} from '~/@core/domain/ui/forms/FormFilterDataModel';
import DefaultRow from '~/components/bosons/DefaultRow';
import SearchButton from '~/components/Buttons/SearchButton';
import { globalContext } from '~/context/GlobalContext';
import useProducerStore from '~/zustand/rfidReports/inventory/producer-state';
import useDoneStore from '~/zustand/rfidReports/receipt/done-state';
import { SearchButtonDiv } from '../../Inventory/Dones/FormFilterInventoryDone.styled';
import { PermissionNames } from '~/constants/permissionNames';

const { Option } = Select;

interface Props {
  formDone: FormInstance<FormFilterDataModel>;
}
export default function FormFilterReceiptDones(props: Props) {
  const { formDone } = props;
  const { t } = useTranslation();
  const { donePagination, addDones, handleDonePagination, setIsLoadingDones } =
    useDoneStore();

  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  useEffect(() => {
    formDone.setFieldsValue({
      dtaFilter: []
    });
  }, [formDone]);

  const { producers, addProducers } = useProducerStore();

  useEffect(() => {
    const permissionName = PermissionNames.RfidReports.MenuReceipt;
    const getProducers = new GetProducers(permissionName);

    handlePromiseUseCase<Producer[], AxiosError>(
      getProducers.execute(),
      (producerOut: any) => {
        addProducers(producerOut);
      },
      (error: any) => {
        activeAlert({
          message: JSON.stringify(
            error.response?.data
              ? error.response?.data
              : 'Houve um erro inesperado!'
          ),
          type: 'error',
          timeout: 5000
        });
      }
    );
  }, []);

  const onSubmitFilterReceiptDones = useCallback(
    (formValues: FormFilterDataModel) => {
      const filterDone = MapFormToFilter.toFilter(formValues, {
        pageSize: donePagination.pageSize,
        pageNumber: donePagination.current
      });

      const getDones = new GetDones();
      setIsLoadingDones();
      handlePromiseUseCase<DefaultPaginated<NonConformity[]>, AxiosError>(
        getDones.execute(filterDone),
        ralizadosOut => {
          addDones(ralizadosOut.results);
          handleDonePagination({
            ...donePagination,
            total: ralizadosOut.totalCount
          });
          setIsLoadingDones();
        },
        error => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
          setIsLoadingDones();
        }
      );
    },
    [
      donePagination,
      setIsLoadingDones,
      handlePromiseUseCase,
      addDones,
      handleDonePagination,
      activeAlert
    ]
  );

  return (
    <Form
      layout="vertical"
      form={formDone}
      onFinish={onSubmitFilterReceiptDones}
    >
      <DefaultRow>
        <Col lg={6}>
          <Form.Item name="dtaFilter" label="Data de Consulta: ">
            <DatePicker.RangePicker
              format="DD/MM/YYYY"
              placeholder={['Início', 'Fim']}
            />
          </Form.Item>
        </Col>
        <Col lg={6}>
          <Form.Item
            name="producerFilter"
            label="Sitio: "
            rules={[{ required: true }]}
          >
            <Select allowClear placeholder="Selecione">
              {producers.map(producer => (
                <Option value={producer.account}>
                  {producer.account} - {producer.tradingName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col lg={3}>
          <SearchButtonDiv>
            <SearchButton
              htmlType="submit"
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {}}
            />
          </SearchButtonDiv>
        </Col>
      </DefaultRow>
    </Form>
  );
}
